/*
  Vanilla replacement for Foundation Tabs.
  Supports the existing markup: ul.tabs[data-tabs][id] with .tabs-title > a[href="#panel"]
  and a matching [data-tabs-content="<id>"] holding .tabs-panel elements.

  Replaces the Foundation "change.zf.tabs" event with "tabs:change" on document.
*/

const ACTIVE = "is-active";

export const TABS_CHANGE_EVENT = "tabs:change";

const getTabsScope = (list) =>
  list.closest(".vertical-tabs") || list.closest(".tabs-wrapper") || document;

const contentFor = (list) => {
  const scope = getTabsScope(list);
  return scope.querySelector(`[data-tabs-content="${list.id}"]`);
};

const panelsFor = (list) => {
  const content = contentFor(list);
  return content
    ? Array.from(content.children).filter((child) =>
        child.classList.contains("tabs-panel"),
      )
    : [];
};

const activate = (list, link) => {
  const targetId = (link.getAttribute("href") || "").replace("#", "");
  if (!targetId) {
    return;
  }

  list.querySelectorAll(".tabs-title").forEach((title) => {
    const isTarget = title.contains(link);
    title.classList.toggle(ACTIVE, isTarget);
    const anchor = title.querySelector("a");
    if (anchor) {
      anchor.setAttribute("aria-selected", String(isTarget));
    }
  });

  panelsFor(list).forEach((panel) => {
    panel.classList.toggle(ACTIVE, panel.id === targetId);
  });

  document.dispatchEvent(
    new CustomEvent(TABS_CHANGE_EVENT, { detail: { list, targetId } }),
  );
};

const setupTabs = (list) => {
  if (list.dataset.tabsReady === "true" || !list.id) {
    return;
  }
  list.dataset.tabsReady = "true";

  const active =
    list.querySelector(`.tabs-title.${ACTIVE} a`) ||
    list.querySelector(".tabs-title a");
  if (active) {
    activate(list, active);
  }

  list.addEventListener("click", (event) => {
    const link = event.target.closest(".tabs-title a");
    if (!link || !list.contains(link)) {
      return;
    }
    event.preventDefault();
    activate(list, link);
  });
};

export const tabsInit = (scope = document) => {
  scope.querySelectorAll("[data-tabs]").forEach(setupTabs);
};

export default tabsInit;
